import { HeroCardBody } from './HeroCardBody';
import { HeroCardCtas } from './HeroCardCtas';
import { HeroCardPostCta } from './HeroCardPostCta';
import type { HeroCardOnlineTabResolved } from './types';

interface HeroCardOnlineTabProps {
  tab: HeroCardOnlineTabResolved;
}

/**
 * Tab 2 ("Nachhilfe Online") is structurally identical on both tabbed cards
 * (SH-312 O6): a rich-text body plus 0…2 CTAs, one of which may be a phone CTA.
 * Both cards render it through this one component so the structure cannot
 * drift — the schemas repeat the field group, the frontend does not.
 */
export function HeroCardOnlineTab({ tab }: HeroCardOnlineTabProps) {
  return (
    <div className="flex w-full flex-col gap-4">
      <HeroCardBody nodes={tab.body} />
      <HeroCardCtas actions={tab.ctas} />
      <HeroCardPostCta postCta={tab.postCta} />
    </div>
  );
}
